import { useState, useEffect } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const PDP_TRUST_MESSAGING_TEST_2_NAME = 'PDP_TrustMessagingTest2_May2026';

export const useIsTrustMessagingTest2Variant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(getAbTestV2(PDP_TRUST_MESSAGING_TEST_2_NAME)?.variant === 'variant');
    }, []);

    return isVariant;
};

export const useTrackTrustMessagingTest2 = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(PDP_TRUST_MESSAGING_TEST_2_NAME);
    }, []);
};
